import { useFormContext, useFieldArray } from 'react-hook-form'
import {
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Plus, Trash2 } from 'lucide-react'
import { SectorFormValues } from './SectorSchema'

export const ListsTab = () => {
  const form = useFormContext<SectorFormValues>()

  const problems = useFieldArray({
    control: form.control,
    name: 'problems',
  })

  const ai = useFieldArray({
    control: form.control,
    name: 'ai_capabilities',
  })

  return (
    <div className="space-y-8">
      {/* Problems List */}
      <div className="space-y-4">
        <div className="flex items-center justify-between border-b pb-2">
          <h3 className="font-semibold text-sm uppercase tracking-wider text-slate-500">
            Sector Problems
          </h3>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => problems.append({ value: '' })}
          >
            <Plus className="w-4 h-4 mr-2" /> Add Problem
          </Button>
        </div>

        <div className="space-y-2">
          {problems.fields.map((field, index) => (
            <div key={field.id} className="flex gap-2">
              <FormField
                control={form.control}
                name={`problems.${index}.value`}
                render={({ field }) => (
                  <FormItem className="flex-1">
                    <FormControl>
                      <Input placeholder="Describe a problem..." {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="text-red-500"
                onClick={() => problems.remove(index)}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* AI Capabilities */}
      <div className="space-y-4">
        <div className="flex items-center justify-between border-b pb-2">
          <h3 className="font-semibold text-sm uppercase tracking-wider text-slate-500">
            AI Capabilities
          </h3>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => ai.append({ value: '' })}
          >
            <Plus className="w-4 h-4 mr-2" /> Add Feature
          </Button>
        </div>

        <div className="space-y-2">
          {ai.fields.map((field, index) => (
            <div key={field.id} className="flex gap-2">
              <FormField
                control={form.control}
                name={`ai_capabilities.${index}.value`}
                render={({ field }) => (
                  <FormItem className="flex-1">
                    <FormControl>
                      <Input placeholder="AI feature..." {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="text-red-500"
                onClick={() => ai.remove(index)}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
